import { render, staticRenderFns } from "./WarehouseReceiptDataTab.vue?vue&type=template&id=1e60e664&scoped=true"
import script from "./WarehouseReceiptDataTab.vue?vue&type=script&lang=js"
export * from "./WarehouseReceiptDataTab.vue?vue&type=script&lang=js"
import style0 from "./WarehouseReceiptDataTab.vue?vue&type=style&index=0&id=1e60e664&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e60e664",
  null
  
)

export default component.exports